type Options = {
  status?: number;
  statusText?: string;
  headers?: Headers;
  url?: string;
};

export default function buildResponse(
  data: string,
  options: Options,
): Response {
  const response = new Response(data);

  for (const optionUntyped in options) {
    if (options.hasOwnProperty(optionUntyped)) {
      const option = optionUntyped as keyof Options;

      Object.defineProperty(response, option, {
        configurable: true,
        enumerable: true,
        get: () => options[option],
      });
    }
  }

  return response;
}
